"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reservedFriendlyIds = exports.paymentCurrencies = exports.acceptedCurrencies = exports.AE_TAX_NUMBERS = exports.AE_SERVICE_TYPE = exports.AE_SCOPE = exports.AE_PERIODICITY = exports.AE_PAYMENT_TYPES = exports.AE_PAYMENT_STATUS = exports.AE_PAYMENT_SOURCES = exports.AE_ORGANIZATION_SUBSCRIPTION_PLANS = exports.AE_ORGANIZATION_SUBSCRIPTION_LEVEL = exports.AE_LOT_STATUS = exports.AE_INVOICE_STATUS = exports.AE_INVOICE_ITEM_STATUS = exports.AE_FRONTEND_EVENT_TYPE = exports.AE_EVENT_SOURCE = exports.AE_CONTACT_INQUIRY_TYPE = exports.AE_CONNECTION_STATUS = exports.AE_CANADIAN_TAXES = exports.AE_BUSINESS_CONTACT = exports.AE_BID_TYPES = exports.AE_BID_SOURCES = exports.AE_AUCTION_TYPE = exports.AE_AUCTION_STATUS = exports.AE_AUCTION_LIVE_UPDATE_TYPE = exports.AE_AUCTION_LIVE_TYPE = exports.AE_AUCTION_LIVE_STATUS_CHANGE = exports.AE_AUCTION_LIVE_STATUS = exports.AE_AUCTION_LIVE_ROLE = exports.AE_AUCTION_LIVE_LOG_ENTRY_TYPE = exports.AE_AUCTION_LIVE_EVENT_TYPE = exports.AE_AUCTION_LIVE_BID_STATUS = exports.AE_AUCTION_LIVE_BID_SOURCE = exports.AE_AUCTION_LIVE_ACTION_TYPE = exports.AE_AUCTION_BID_MODE = exports.countryCurrency = undefined;
exports.isAuctionOver = isAuctionOver;
exports.isAuctionReadOnly = isAuctionReadOnly;

var _AE_AUCTION_STATUS2 = require("./AE_AUCTION_STATUS");

var _AE_AUCTION_STATUS3 = _interopRequireDefault(_AE_AUCTION_STATUS2);

var _countryCurrency2 = require("./countryCurrency");

var _countryCurrency3 = _interopRequireDefault(_countryCurrency2);

var _AE_AUCTION_BID_MODE2 = require("./AE_AUCTION_BID_MODE");

var _AE_AUCTION_BID_MODE3 = _interopRequireDefault(_AE_AUCTION_BID_MODE2);

var _AE_AUCTION_LIVE_ACTION_TYPE2 = require("./AE_AUCTION_LIVE_ACTION_TYPE");

var _AE_AUCTION_LIVE_ACTION_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_ACTION_TYPE2);

var _AE_AUCTION_LIVE_BID_SOURCE2 = require("./AE_AUCTION_LIVE_BID_SOURCE");

var _AE_AUCTION_LIVE_BID_SOURCE3 = _interopRequireDefault(_AE_AUCTION_LIVE_BID_SOURCE2);

var _AE_AUCTION_LIVE_BID_STATUS2 = require("./AE_AUCTION_LIVE_BID_STATUS");

var _AE_AUCTION_LIVE_BID_STATUS3 = _interopRequireDefault(_AE_AUCTION_LIVE_BID_STATUS2);

var _AE_AUCTION_LIVE_EVENT_TYPE2 = require("./AE_AUCTION_LIVE_EVENT_TYPE");

var _AE_AUCTION_LIVE_EVENT_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_EVENT_TYPE2);

var _AE_AUCTION_LIVE_LOG_ENTRY_TYPE2 = require("./AE_AUCTION_LIVE_LOG_ENTRY_TYPE");

var _AE_AUCTION_LIVE_LOG_ENTRY_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_LOG_ENTRY_TYPE2);

var _AE_AUCTION_LIVE_ROLE2 = require("./AE_AUCTION_LIVE_ROLE");

var _AE_AUCTION_LIVE_ROLE3 = _interopRequireDefault(_AE_AUCTION_LIVE_ROLE2);

var _AE_AUCTION_LIVE_STATUS2 = require("./AE_AUCTION_LIVE_STATUS");

var _AE_AUCTION_LIVE_STATUS3 = _interopRequireDefault(_AE_AUCTION_LIVE_STATUS2);

var _AE_AUCTION_LIVE_STATUS_CHANGE2 = require("./AE_AUCTION_LIVE_STATUS_CHANGE");

var _AE_AUCTION_LIVE_STATUS_CHANGE3 = _interopRequireDefault(_AE_AUCTION_LIVE_STATUS_CHANGE2);

var _AE_AUCTION_LIVE_TYPE2 = require("./AE_AUCTION_LIVE_TYPE");

var _AE_AUCTION_LIVE_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_TYPE2);

var _AE_AUCTION_LIVE_UPDATE_TYPE2 = require("./AE_AUCTION_LIVE_UPDATE_TYPE");

var _AE_AUCTION_LIVE_UPDATE_TYPE3 = _interopRequireDefault(_AE_AUCTION_LIVE_UPDATE_TYPE2);

var _AE_AUCTION_TYPE2 = require("./AE_AUCTION_TYPE");

var _AE_AUCTION_TYPE3 = _interopRequireDefault(_AE_AUCTION_TYPE2);

var _AE_BID_SOURCES2 = require("./AE_BID_SOURCES");

var _AE_BID_SOURCES3 = _interopRequireDefault(_AE_BID_SOURCES2);

var _AE_BID_TYPES2 = require("./AE_BID_TYPES");

var _AE_BID_TYPES3 = _interopRequireDefault(_AE_BID_TYPES2);

var _AE_BUSINESS_CONTACT2 = require("./AE_BUSINESS_CONTACT");

var _AE_BUSINESS_CONTACT3 = _interopRequireDefault(_AE_BUSINESS_CONTACT2);

var _AE_CANADIAN_TAXES2 = require("./AE_CANADIAN_TAXES");

var _AE_CANADIAN_TAXES3 = _interopRequireDefault(_AE_CANADIAN_TAXES2);

var _AE_CONNECTION_STATUS2 = require("./AE_CONNECTION_STATUS");

var _AE_CONNECTION_STATUS3 = _interopRequireDefault(_AE_CONNECTION_STATUS2);

var _AE_CONTACT_INQUIRY_TYPE2 = require("./AE_CONTACT_INQUIRY_TYPE");

var _AE_CONTACT_INQUIRY_TYPE3 = _interopRequireDefault(_AE_CONTACT_INQUIRY_TYPE2);

var _AE_EVENT_SOURCE2 = require("./AE_EVENT_SOURCE");

var _AE_EVENT_SOURCE3 = _interopRequireDefault(_AE_EVENT_SOURCE2);

var _AE_FRONTEND_EVENT_TYPE2 = require("./AE_FRONTEND_EVENT_TYPE");

var _AE_FRONTEND_EVENT_TYPE3 = _interopRequireDefault(_AE_FRONTEND_EVENT_TYPE2);

var _AE_INVOICE_ITEM_STATUS2 = require("./AE_INVOICE_ITEM_STATUS");

var _AE_INVOICE_ITEM_STATUS3 = _interopRequireDefault(_AE_INVOICE_ITEM_STATUS2);

var _AE_INVOICE_STATUS2 = require("./AE_INVOICE_STATUS");

var _AE_INVOICE_STATUS3 = _interopRequireDefault(_AE_INVOICE_STATUS2);

var _AE_LOT_STATUS2 = require("./AE_LOT_STATUS");

var _AE_LOT_STATUS3 = _interopRequireDefault(_AE_LOT_STATUS2);

var _AE_ORGANIZATION_SUBSCRIPTION_LEVEL2 = require("./AE_ORGANIZATION_SUBSCRIPTION_LEVEL");

var _AE_ORGANIZATION_SUBSCRIPTION_LEVEL3 = _interopRequireDefault(_AE_ORGANIZATION_SUBSCRIPTION_LEVEL2);

var _AE_ORGANIZATION_SUBSCRIPTION_PLANS2 = require("./AE_ORGANIZATION_SUBSCRIPTION_PLANS");

var _AE_ORGANIZATION_SUBSCRIPTION_PLANS3 = _interopRequireDefault(_AE_ORGANIZATION_SUBSCRIPTION_PLANS2);

var _AE_PAYMENT_SOURCES2 = require("./AE_PAYMENT_SOURCES");

var _AE_PAYMENT_SOURCES3 = _interopRequireDefault(_AE_PAYMENT_SOURCES2);

var _AE_PAYMENT_STATUS2 = require("./AE_PAYMENT_STATUS");

var _AE_PAYMENT_STATUS3 = _interopRequireDefault(_AE_PAYMENT_STATUS2);

var _AE_PAYMENT_TYPES2 = require("./AE_PAYMENT_TYPES");

var _AE_PAYMENT_TYPES3 = _interopRequireDefault(_AE_PAYMENT_TYPES2);

var _AE_PERIODICITY2 = require("./AE_PERIODICITY");

var _AE_PERIODICITY3 = _interopRequireDefault(_AE_PERIODICITY2);

var _AE_SCOPE2 = require("./AE_SCOPE");

var _AE_SCOPE3 = _interopRequireDefault(_AE_SCOPE2);

var _AE_SERVICE_TYPE2 = require("./AE_SERVICE_TYPE");

var _AE_SERVICE_TYPE3 = _interopRequireDefault(_AE_SERVICE_TYPE2);

var _AE_TAX_NUMBERS2 = require("./AE_TAX_NUMBERS");

var _AE_TAX_NUMBERS3 = _interopRequireDefault(_AE_TAX_NUMBERS2);

var _acceptedCurrencies2 = require("./acceptedCurrencies");

var _acceptedCurrencies3 = _interopRequireDefault(_acceptedCurrencies2);

var _paymentCurrencies2 = require("./paymentCurrencies");

var _paymentCurrencies3 = _interopRequireDefault(_paymentCurrencies2);

var _reservedFriendlyIds2 = require("./reservedFriendlyIds");

var _reservedFriendlyIds3 = _interopRequireDefault(_reservedFriendlyIds2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAuctionOver(auction) {
  if (!auction || !auction.hasOwnProperty("status")) {
    throw new Error("You need to provide an auction object with a 'status' property.");
  }

  return auction.status === _AE_AUCTION_STATUS3.default.FINISHED || auction.status === _AE_AUCTION_STATUS3.default.CANCELLED;
} /**
   * Copyright 2013-present, Novivia, Inc.
   * All rights reserved.
   */

/**
 * Combinations
 */

function isAuctionReadOnly(auction) {
  if (!auction || !auction.hasOwnProperty("status")) {
    throw new Error("You need to provide an auction object with a 'status' property.");
  }

  return auction.status === _AE_AUCTION_STATUS3.default.ONGOING || isAuctionOver(auction);
}

exports.countryCurrency = _countryCurrency3.default;

/**
 * Exports
 */

// Enums.

exports.AE_AUCTION_BID_MODE = _AE_AUCTION_BID_MODE3.default;
exports.AE_AUCTION_LIVE_ACTION_TYPE = _AE_AUCTION_LIVE_ACTION_TYPE3.default;
exports.AE_AUCTION_LIVE_BID_SOURCE = _AE_AUCTION_LIVE_BID_SOURCE3.default;
exports.AE_AUCTION_LIVE_BID_STATUS = _AE_AUCTION_LIVE_BID_STATUS3.default;
exports.AE_AUCTION_LIVE_EVENT_TYPE = _AE_AUCTION_LIVE_EVENT_TYPE3.default;
exports.AE_AUCTION_LIVE_LOG_ENTRY_TYPE = _AE_AUCTION_LIVE_LOG_ENTRY_TYPE3.default;
exports.AE_AUCTION_LIVE_ROLE = _AE_AUCTION_LIVE_ROLE3.default;
exports.AE_AUCTION_LIVE_STATUS = _AE_AUCTION_LIVE_STATUS3.default;
exports.AE_AUCTION_LIVE_STATUS_CHANGE = _AE_AUCTION_LIVE_STATUS_CHANGE3.default;
exports.AE_AUCTION_LIVE_TYPE = _AE_AUCTION_LIVE_TYPE3.default;
exports.AE_AUCTION_LIVE_UPDATE_TYPE = _AE_AUCTION_LIVE_UPDATE_TYPE3.default;
exports.AE_AUCTION_STATUS = _AE_AUCTION_STATUS3.default;
exports.AE_AUCTION_TYPE = _AE_AUCTION_TYPE3.default;
exports.AE_BID_SOURCES = _AE_BID_SOURCES3.default;
exports.AE_BID_TYPES = _AE_BID_TYPES3.default;
exports.AE_BUSINESS_CONTACT = _AE_BUSINESS_CONTACT3.default;
exports.AE_CANADIAN_TAXES = _AE_CANADIAN_TAXES3.default;
exports.AE_CONNECTION_STATUS = _AE_CONNECTION_STATUS3.default;
exports.AE_CONTACT_INQUIRY_TYPE = _AE_CONTACT_INQUIRY_TYPE3.default;
exports.AE_EVENT_SOURCE = _AE_EVENT_SOURCE3.default;
exports.AE_FRONTEND_EVENT_TYPE = _AE_FRONTEND_EVENT_TYPE3.default;
exports.AE_INVOICE_ITEM_STATUS = _AE_INVOICE_ITEM_STATUS3.default;
exports.AE_INVOICE_STATUS = _AE_INVOICE_STATUS3.default;
exports.AE_LOT_STATUS = _AE_LOT_STATUS3.default;
exports.AE_ORGANIZATION_SUBSCRIPTION_LEVEL = _AE_ORGANIZATION_SUBSCRIPTION_LEVEL3.default;
exports.AE_ORGANIZATION_SUBSCRIPTION_PLANS = _AE_ORGANIZATION_SUBSCRIPTION_PLANS3.default;
exports.AE_PAYMENT_SOURCES = _AE_PAYMENT_SOURCES3.default;
exports.AE_PAYMENT_STATUS = _AE_PAYMENT_STATUS3.default;
exports.AE_PAYMENT_TYPES = _AE_PAYMENT_TYPES3.default;
exports.AE_PERIODICITY = _AE_PERIODICITY3.default;
exports.AE_SCOPE = _AE_SCOPE3.default;
exports.AE_SERVICE_TYPE = _AE_SERVICE_TYPE3.default;
exports.AE_TAX_NUMBERS = _AE_TAX_NUMBERS3.default;

// Lists.

exports.acceptedCurrencies = _acceptedCurrencies3.default;
exports.paymentCurrencies = _paymentCurrencies3.default;
exports.reservedFriendlyIds = _reservedFriendlyIds3.default;


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/configurations/lib/common/index.js
// module id = 75
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54